module.exports = __webpack_public_path__ + "img/sello.8fa61b77.png";